import React from 'react';

import { Button, ButtonProps, Box, SxProps } from '@mui/material';
import { Asterisk, ArrowRight, Circle, SignIn, SignOut, ArrowSquareOut, ArrowLeft } from 'phosphor-react';
import CoinIcon from 'public/v2/icons/coin.svg';

import { secondaryColors, white } from '~components/theme/styles/colors';

import { IconColorWrapper } from '../../icons/iconColorWrapper';

export type ButtonWithIconProps = ButtonProps & {
  fontSize?: number;
  iconType?: 'arrow' | 'circle' | 'in' | 'out' | 'asterisk' | 'popout' | 'coin' | 'back';
  iconSize?: number;
  iconPlacement?: 'left' | 'right';
  iconSx?: SxProps;
};

export const ButtonWithIcon = ({
  fontSize,
  variant = 'secondary',
  sx,
  children,
  iconType = 'arrow',
  iconSize,
  iconSx,
  iconPlacement = 'right',
  disabled,
  ...props
}: ButtonWithIconProps) => {
  let icon = null;

  switch (iconType) {
    case 'back':
      icon = <ArrowLeft size={iconSize ?? 12} />;
      break;
    case 'arrow':
      icon = <ArrowRight size={iconSize ?? 12} />;
      break;
    case 'asterisk':
      icon = <Asterisk size={iconSize ?? 12} />;
      break;
    case 'circle':
      icon = <Circle size={iconSize ?? 9} />;
      break;
    case 'in':
      icon = <SignIn size={iconSize ?? 16} weight="bold" />;
      break;
    case 'out':
      icon = <SignOut size={iconSize ?? 16} weight="bold" />;
      break;
    case 'popout':
      icon = <ArrowSquareOut size={iconSize ?? 16} weight="bold" />;
      break;
    case 'coin':
      icon = (
        <IconColorWrapper color={disabled ? white['15%'] : secondaryColors[200]}>
          <CoinIcon width="24px" height="24px" />
        </IconColorWrapper>
      );
      break;
  }

  return (
    <Button
      variant={variant}
      {...props}
      disabled={disabled}
      sx={{
        display: 'flex',
        width: '100%',
        height: 42,
        justifyContent: iconPlacement === 'right' ? 'space-between' : 'start',
        fontSize: fontSize,
        alignItems: 'center',
        ...sx,
      }}
    >
      {iconPlacement === 'left' ? (
        <Box position={'relative'} top={2} sx={iconSx}>
          {icon}
        </Box>
      ) : null}
      {children ? (
        <Box ml={iconPlacement === 'left' ? 2 : 0} fontSize={fontSize}>
          {children}
        </Box>
      ) : null}
      {iconPlacement === 'right' ? (
        <Box position={'relative'} top={2} sx={iconSx}>
          {icon}
        </Box>
      ) : null}
    </Button>
  );
};
